// extracted by mini-css-extract-plugin
export var button = "k_L";
export var button1 = "k_M";
export var button2 = "k_N";
export var button3 = "k_P";
export var button4 = "k_Q";
export var button5 = "k_R";
export var buttonInner = "k_S";